import { useEffect, useRef, useState } from "react";
import { CircularProgress, Divider, Grid2, IconButton, TextField, Typography } from "@mui/material";
import { ArrowBackIos, Send, SupportAgent } from "@mui/icons-material";
// import socket from "../../../socket";
import { useAuth } from "../../../hooks/useAuth";
import api from "../../../utils/axios";
import { ILivechatMessage } from "sierra";
import { TChatPanel } from "./ChatFab";
import socket from "../../../utils/socket";
import { useApp } from "../../../contexts/AppContext";

export default function LiveChatPanel({ switchPanel, unreadCount }: { switchPanel: (panel: TChatPanel) => void, unreadCount: number }) {
    const { user, userLoaded } = useAuth()
    const {lang} = useApp()
    
    const [messages, setMessages] = useState<ILivechatMessage[]>();
    const [message, setMessage] = useState('');
    const [apiCalling, setApiCalling] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!userLoaded) return
        if (user) {
            fetchData()
            socket.on("live_chat_messages_changed", fetchData);
            return () => {
                socket.off("live_chat_messages_changed", fetchData);
            }
        }
    }, [userLoaded])

    useEffect(() => {
        if (unreadCount !== 0) markAsRead()
    }, [unreadCount])

    useEffect(() => {
        // Scroll to the bottom when messages change
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [messages]);

    const fetchData = () => {
        api.get('/livechat/messages').then(res => setMessages(res.data)).catch(console.error)
    }

    const markAsRead = () => {
        api.patch('/livechat/messages/messageRead').catch(console.error)
    }

    const apiCall = () => {
        setApiCalling(true)
        api.post('/livechat/messages', { message: message, }).then(() => {
            setApiCalling(false)
            setMessage('')
        }).catch(console.error).finally(() => setApiCalling(false))
    }

    if (!messages) return <CircularProgress sx={{ alignSelf: 'center', marginTop: '40%', color: 'secondary.main' }} />

    return (
        // <Badge badgeContent={expanded ? 0 : messages?.filter(m => m.message_read_customer == false).length} color="primary">
        <Grid2 container flexDirection={'column'} height={'100%'} padding={1.5} gap={1}>
            <Grid2 container justifyContent={'center'} gap={1} position={'relative'}>
                <Grid2 position={'absolute'} left={0} paddingTop={0.5} sx={{ cursor: 'pointer' }}>
                    <ArrowBackIos fontSize={'small'} color="secondary" onClick={() => switchPanel('chatbot')} />
                </Grid2>
                <Grid2>
                    <SupportAgent color="secondary" />
                </Grid2>
                <Grid2>
                    <Typography color="primary.contrastText">Live Chat</Typography>
                </Grid2>
            </Grid2>
            <Grid2>
                <Divider orientation="horizontal" color='white' />
            </Grid2>
            <Grid2 container size='grow' display={'flex'} overflow={'auto'} ref={containerRef} flexDirection={'column'} wrap="nowrap" paddingRight={1}>
                {messages.map((m, i) =>
                    <Grid2 container key={i} flexDirection={'column'}>
                        <Grid2 display={'flex'} justifyContent={m.sender_id == user?.user_id ? 'right' : 'left'}>
                            <Typography
                                sx={{
                                    backgroundColor: m.sender_id == user?.user_id ? 'primary.main' : 'lightgrey',
                                    color: m.sender_id == user?.user_id ? 'primary.contrastText' : undefined,
                                    display: 'inline-block',
                                    maxWidth: '90%',
                                    padding: 1,
                                    borderRadius: 6,
                                    marginY: 0.5
                                }}
                            >{m.message}
                            </Typography>
                        </Grid2>
                        <Grid2 display={m.sender_id == messages[i + 1]?.sender_id ? 'none' : 'flex'} justifyContent={m.sender_id == user?.user_id ? 'right' : 'left'}>
                            <Typography style={{
                                direction: 'ltr',
                                color: '#b8b8b8',
                                fontSize: 12
                            }}>{new Date(m.creation_timestamp).toLocaleString(lang === 'ar' ? 'ar-SD' : undefined)}</Typography>
                        </Grid2>
                    </Grid2>
                )}
            </Grid2>
            <Grid2>
                <Divider orientation="horizontal" color='white' />
            </Grid2>
            <Grid2 container size='auto' display={'flex'} alignItems={'center'} gap={0.5} sx={{ direction: 'ltr' }}>
                <Grid2 size={'grow'} display={'flex'} alignItems={'center'} >
                    <TextField color="secondary" sx={{ input: { color: 'primary.contrastText' } }} size='small' fullWidth value={message} onChange={(e) => setMessage(e.target.value)} disabled={apiCalling} onKeyUp={e => e.key === 'Enter' ? apiCall() : undefined} />
                </Grid2>
                <Grid2 size={'auto'} display={'flex'} justifyContent={'center'}>
                    <IconButton onClick={apiCall} disabled={apiCalling || !message}>
                        {apiCalling ? <CircularProgress size={24} color="secondary" /> : <Send color="secondary" />}
                    </IconButton>
                </Grid2>
            </Grid2>
        </Grid2>
        // </Badge>
    )
}
